/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DnepduosEntity { 
    dnedane: string;
    id?: number;
    label?: string;
    paragraf: string;
    paragrafInt?: number;
    pismpar: string;
    pocpl: string;
    prenrne: string;
    rokc: string;
    rozdpism: string;
    stav: string;
    text: string;
    ukopl?: string;
}

